import { useCallback, useMemo, useState } from 'react';

import endOfDay from 'date-fns/endOfDay';
import startOfDay from 'date-fns/startOfDay';

import { DateFilter } from '@sbv-clients/domain-ui-shared';
import { Box } from '@sbv-clients/ui-shared';

import { useCallOffsReportGet } from '../../../../../services/dashboard';
import CallOffsGrid from './call-offs-grid';

interface MainProps {
  departmentId: number;
  positionId: number;
  date: Date;
}

const Main = ({ departmentId, positionId, date }: MainProps) => {
  const [startDate, setStartDate] = useState(date);
  const [endDate, setEndDate] = useState(date);

  const onStartDateChange = useCallback(
    (value: Date | null) => {
      if (value) {
        setStartDate(value);
      }
    },
    [setStartDate]
  );
  const onEndDateChange = useCallback(
    (value: Date | null) => {
      if (value) {
        setEndDate(value);
      }
    },
    [setEndDate]
  );

  const dateRange = useMemo(() => {
    return [startOfDay(new Date(startDate)), endOfDay(new Date(endDate))];
  }, [endDate, startDate]);

  const response = useCallOffsReportGet(
    departmentId,
    positionId,
    dateRange[0],
    dateRange[1]
  );
  return (
    <Box pt={4}>
      <Box
        display="grid"
        columnGap={2}
        gridTemplateColumns="repeat(auto-fill, minmax(225px, 1fr))"
      >
        <DateFilter
          useContextFn={() => ({ date: startDate, setDate: onStartDateChange })}
        />
        <DateFilter
          useContextFn={() => ({ date: endDate, setDate: onEndDateChange })}
        />
      </Box>
      <Box mt={4} height={500} display="grid" gridTemplateRows="1fr">
        <CallOffsGrid callOffResponse={response} />
      </Box>
    </Box>
  );
};

export default Main;
